import React from 'react';

import StepReview from './StepReview';
import ReviewItem from './ReviewItem';
import { getApp, getAllStates } from '../../../index';

class ApplicationReview extends React.Component {
    render() {
        var allStates = getAllStates();
        var caSSN = getApp('ca_ssn');
        var caStringSSN = (
            <span>
                Co-Applicant's Social Security Number:  <strong>{ssn4(caSSN)}</strong>
            </span>
        );
        function ssn4(num) { // mask ssn
            var slice = num.slice(7);
            return "XXX-XX-" + slice;
        }

        return (
            <div id="overview" className="application-review hug">
                <div className="step-review product">
                    <strong>Your application for {allStates.product ? allStates.product : "undefined product"}.</strong>
                </div>
                <StepReview stepLink="identity" fixedFields={true}>
                    <span>First Name: <strong>{allStates.fname}</strong><br /></span>
                    <ReviewItem label="Middle Name:" appKey="mname" />
                    <span>Last Name: <strong>{allStates.lname}</strong><br /></span>
                    <span>Email Address: <strong>{allStates.email}</strong><br /></span>
                    <span>Phone Number: <strong>{allStates.phone}</strong><br /></span>
                    <span>Phone Type: <strong>{allStates.phoneType}</strong><br /></span>
                </StepReview>
                <StepReview stepLink="verification" fixedFields={true}>
                    <span>Date of Birth: <strong>{allStates.dob}</strong><br /></span>
                    <span>Social Security Number: <strong>{ssn4(allStates.ssn)}</strong><br /></span>
                    {/* <span>Marital Status: <strong>{allStates.maritalStatus}</strong><br /></span> */}
                </StepReview>
                <StepReview stepLink="address" fixedFields={true}>
                    <span>Address: <strong>{allStates.address}</strong><br /></span>
                    <ReviewItem label="Address 2:" appKey="address2" />
                    <span>City: <strong>{allStates.city}</strong><br /></span>
                    <span>State: <strong>{allStates.state}</strong><br /></span>
                    <span>Zip Code: <strong>{allStates.zipcode}</strong><br /></span>
                    <span>Housing Type: <strong>{allStates.ownershipStatus}</strong><br /></span>
                    <ReviewItem label="Monthly Payment:" appKey="monthlyPayment" />
                    <span>Years at Address: <strong>{allStates.yearsAtAddress}</strong><br /></span>
                    <span>Months at Address: <strong>{allStates.monthsAtAddress}</strong><br /></span>
                    <ReviewItem label="Mailing Address:" appKey="mailingAddress" />
                    <ReviewItem label="Mailing Address 2:" appKey="mailingAddress2" />
                    <ReviewItem label="Mailing City:" appKey="mailingCity" />
                    <ReviewItem label="Mailing State:" appKey="mailingState" />
                    <ReviewItem label="Mailing Zip Code:" appKey="mailingZipcode" />
                </StepReview>
                <StepReview stepLink="work" fixedFields={true}>
                    <span>Employment Status: <strong>{allStates.employmentStatus}</strong><br /></span>
                    <ReviewItem label="Employer:" appKey="employer" />
                    <ReviewItem label="Company Name:" appKey="companyName" />
                    <ReviewItem label="Years with Employer:" appKey="yearsEmployer" />
                    <ReviewItem label="Months with Employer:" appKey="monthsEmployer" />
                    <span>Position or Title: <strong>{allStates.position}</strong><br /></span>
                    <span>Gross Annual Income: <strong>{allStates.annualIncome}</strong><br /></span>
                    <ReviewItem label="Vantage West Employee:" appKey="vwEmployee" />
                </StepReview>
                <StepReview stepLink="co-applicant" fixedFields={true}>
                    Co-Applicant Type: <strong>{allStates.coApplicantType}</strong> <br />
                </StepReview>
                <StepReview stepLink="co-applicant-info" fixedFields={false}>
                    <ReviewItem label="Co-Applicant's First Name:" appKey="ca_fname" />
                    <ReviewItem label="Co-Applicant's Middle Name:" appKey="ca_mname" />
                    <ReviewItem label="Co-Applicant's Last Name:" appKey="ca_lname" />
                    <ReviewItem label="Co-Applicant's Date of Birth:" appKey="ca_dob" />
                    {caSSN ? caStringSSN : ""}
                </StepReview>
                <StepReview stepLink="co-applicant-contact" fixedFields={false}>
                    <ReviewItem label="Co-Applicant's Address:" appKey="caAddress" />
                    <ReviewItem label="Co-Applicant's Address 2:" appKey="caAddress2" />
                    <ReviewItem label="Co-Applicant's City:" appKey="caCity" />
                    <ReviewItem label="Co-Applicant's State:" appKey="caState" />
                    <ReviewItem label="Co-Applicant's Zip Code:" appKey="caZip" />
                    <ReviewItem label="Co-Applicant's Years at Address:" appKey="caYears" />
                    <ReviewItem label="Co-Applicant's Months at Address:" appKey="caMonths" />
                    <ReviewItem label="Co-Applicant's Monthly Payment:" appKey="caMonthlyPayment" />
                    <ReviewItem label="Co-Applicant's Phone Number:" appKey="caPhone" />
                    <ReviewItem label="Co-Applicant's Phone Type:" appKey="caPhoneType" />
                    <ReviewItem label="Co-Applicant's Mailing Address:" appKey="coAppMailingAddress" />
                    <ReviewItem label="Co-Applicant's Mailing Address 2:" appKey="coAppMailingAddress2" />
                    <ReviewItem label="Co-Applicant's Mailing City:" appKey="coAppMailingCity" />
                    <ReviewItem label="Co-Applicant's Mailing State:" appKey="coAppMailingState" />
                    <ReviewItem label="Co-Applicant's Mailing Zip Code:" appKey="coAppMailingZipcode" />
                </StepReview>
                <StepReview stepLink="co-applicant-work" fixedFields={false}>
                    <ReviewItem label="Co-Applicant's Employment Status:" appKey="caEmploymentStatus" />
                    <ReviewItem label="Co-Applicant's Employer:" appKey="caEmployer" />
                    <ReviewItem label="Co-Applicant's Company Name:" appKey="caCompanyName" />
                    <ReviewItem label="Co-Applicant's Years with Employer:" appKey="caYearsEmployer" />
                    <ReviewItem label="Co-Applicant's Months with Employer:" appKey="caMonthsEmployer" />
                    <ReviewItem label="Co-Applicant's Position:" appKey="caPosition" />
                    <ReviewItem label="Co-Applicant's Gross Annual Income:" appKey="caAnnualIncome" />
                    <ReviewItem label="Co-Applicant is A Vantage West Employee:" appKey="caVWEmployee" />
                </StepReview>
                <StepReview stepLink="authorized-user" fixedFields={true}>
                   Request Authorized Users: <strong>{allStates.authorizedUser}</strong> <br />
                </StepReview>
                <StepReview stepLink="balance-transfer" fixedFields={true}>
                   Request Balance Transfer: <strong>{allStates.balanceTransfer}</strong> <br />
                </StepReview>
            </div>
        )
    }
}

export default ApplicationReview;